import React from "react";
import Loader from "../../common/Loader/Loader";
import SingleRow from "./SingleRow";
import classes from "./DataTable.module.css";
const DataTable = ({ data, loader }) => {
  return (
    <div className={classes.tableContainer}>
      {loader && <Loader />}
      <table>
        <thead>
          <tr>
            <th>stakeID</th>
            <th>amount</th>
            <th>id</th>
            <th>user</th>
            <th>transactionHash</th>
            <th>blockNumber</th>
            <th>apr</th>
            <th className={classes.txIdContainer}>Time</th>
            <th>lastWithdrawnTime</th>
            <th>ref1</th>
            <th>ref2</th>
            <th>ref3</th>
            <th>ref4</th>
            <th>ref5</th>
            <th>unlockTime</th>
            <th>withdrawnAmount</th>
          </tr>
        </thead>
        <tbody>
          {data.map((el, idx) => {
            return <SingleRow {...el} key={"table-row-" + idx} />;
          })}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;
